import { ImageWrapper, PrimaryButton } from '@geneo2-web/shared-ui';
import { Checkbox, TextField, Typography } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { IStyles } from 'libs/shared-ui/src/commonUtils/styleUtils';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { ReactNode } from 'react';

const styles: IStyles = {
  root: {
    width: '100%',
    height: { xs: '100%' },
    backgroundColor: '#F5FAFF',
    borderRadius: pxTovW(15),
    border: '1px solid #A8D3FC',
  },
};
interface IProps {
  value: string | undefined;
  onChange?: (e: string | undefined) => void;
  // allowAI?: boolean;
  // setAllowAI?: (e: boolean) => void;
  validationEnabled?: boolean;
  validated?: 'success' | 'error';
  onValidateClick?: () => void;
  rootStyles?: SxProps;
  textFieldBoxStyles?: SxProps;
  textFieldStyles?: SxProps;
  helperText?: string;
  helperFooter?: ReactNode;
}
export const AiPromptTextEditor = (props: IProps) => {
  const {
    onChange,
    value,
    // allowAI,
    // setAllowAI,
    validationEnabled,
    validated,
    onValidateClick,
    rootStyles,
    textFieldBoxStyles,
    textFieldStyles,
    helperText,
    helperFooter,
  } = props;

  let rootSx = { ...styles.root };
  if (rootStyles) rootSx = { ...rootSx, ...rootStyles };
  return (
    <Box sx={rootSx}>
      {/* <Box
        sx={{
          width: '100%',
          display: 'flex',
          gap: { xs: pxToRem(10), md: pxTovW(0) },
          alignItems: 'center',
          borderBottom: '1px solid #A8D3FC',
        }}
      >
        <Checkbox
          sx={{ color: '#00A8FF' }}
          checked={allowAI}
          onChange={(e) => {
            e.target.checked === false && onChange && onChange('');
            setAllowAI && setAllowAI(e.target.checked);
          }}
        />
        <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
          Allow AI Generated Questions
        </Typography>
      </Box> */}
      <Box
        sx={{
          display: 'flex',
          boxSizing: 'border-box',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: { xs: pxToRem(10), md: pxTovW(20) },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 'bold',
            color: '#222121',
            // opacity: allowAI ? 1 : 0.1,
          }}
        >
          Edit Prompt
        </Typography>
        {validationEnabled &&
          (!validated ? (
            <PrimaryButton
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 'max-content',
                borderRadius: { xs: pxToRem(8), md: pxTovW(10) },
                fontSize: { xs: pxToRem(14), md: pxTovW(16) },
                padding: { xs: pxToRem(6), md: pxTovW(8) },
                height: 'unset',
                boxShadow: 'none',
              }}
              onClick={() => {
                onValidateClick ? onValidateClick() : null;
              }}
              disabled={!value}
            >
              <Typography
                variant="cardText"
                color={'#fff'}
                sx={{ lineHeight: 1 }}
              >
                VALIDATE
              </Typography>
            </PrimaryButton>
          ) : (
            <Box
              sx={{
                backgroundColor: validated == 'success' ? '#D4FFE7' : '#FFE9E9',
                border:
                  validated == 'success'
                    ? '1px solid #0AA34F57'
                    : '1px solid #F54040',
                p: '3px 7px',
                borderRadius: '35px',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              {validated == 'success' ? (
                <CheckCircleIcon fontSize="small" sx={{ color: '#0F8F10' }} />
              ) : (
                <CancelIcon fontSize="small" sx={{ color: '#F54040' }} />
              )}
              <Typography
                variant="cardText"
                color={'#000'}
                sx={{ lineHeight: 1 }}
              >
                {validated == 'success' ? 'Prompt Validated' : 'Invalid Prompt'}
              </Typography>
            </Box>
          ))}
        {/* {value === '' ? (
            <ImageWrapper
              name="edit"
              type="png"
              parentFolder="icons"
              styles={{
                width: { xs: pxToRem(24), md: pxTovW(24) },
                height: { xs: pxToRem(23), md: pxTovW(23) },
                cursor: 'pointer',
              }}
            />
          ) : (
            <PrimaryButton
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: { xs: pxToRem(40), md: pxTovW(50) },
                height: { xs: pxToRem(20), md: pxTovW(23) },
                borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 'bold',
                  color: 'white',
                }}
              >
                Save
              </Typography>
            </PrimaryButton>
          )} */}
      </Box>
      <Box
        sx={{
          boxSizing: 'border-box',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: {
            xs: pxToRem(10),
            md: pxTovW(20),
          },
          gap: {
            xs: pxToRem(10),
            md: pxTovW(20),
          },
        }}
      >
        <Box
          sx={{
            boxSizing: 'border-box',
            overflow: 'hidden',
            height: { xs: pxToRem(100), md: pxTovW(131) },
            ...textFieldBoxStyles,
          }}
        >
          <TextField
            // disabled={!allowAI}
            sx={{
              boxSizing: 'border-box',
              width: '100%',
              // height: '100%',
              height: { xs: pxToRem(100), md: pxTovW(131) },

              borderRadius: pxToRem(9),
              // paddingY: pxToRem(10),
              backgroundColor: 'white',
              overflowY: 'auto',
              '&>div': {
                '&::-webkit-scrollbar': { display: 'none' },
              },
              '& > div > textarea': {
                '&::-webkit-scrollbar': { display: 'none' },
                height: { xs: pxToRem(100), md: pxTovW(83) },
              },
              ...textFieldStyles,
            }}
            placeholder={'Type Your Prompt Here...'}
            multiline
            rows={4}
            variant="outlined"
            value={value || ''}
            onChange={(e) => {
              onChange && onChange(e.target.value);
            }}
          />
        </Box>
        {helperText ? (
          <Typography
            variant="h4"
            sx={{
              color: '#c2c7ca',
              fontWeight: 400,
              lineHeight: 1.4,
            }}
          >
            {helperText}
          </Typography>
        ) : null}
        {helperFooter}
      </Box>
    </Box>
  );
};
